module.exports = __webpack_public_path__ + "static/media/log_out.ca073b2b.svg";